import { render, staticRenderFns } from "./PaymentsToRelease.vue?vue&type=template&id=1037f2ce&scoped=true&"
import script from "./PaymentsToRelease.vue?vue&type=script&lang=js&"
export * from "./PaymentsToRelease.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsToRelease.vue?vue&type=style&index=0&id=1037f2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1037f2ce",
  null
  
)

export default component.exports